/* eslint-disable react/no-unescaped-entities */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import JoinNowButton from 'components/common/JoinNowButton';

const Footer = () => {
  return (
    <Box>
      
      <Box
        component={Typography}
        fontWeight={700}
        variant={'h3'}
        gutterBottom
        align={'center'}
      >
        Get started with Nabor Labor
      </Box>
      <Typography
        variant={'h6'}
        component={'p'}
        color={'textSecondary'}
        align={'center'}
      >
        Join today, sleep better tonight.
      </Typography>
      <Box marginTop={3} display={'flex'} justifyContent={'center'}>
        <JoinNowButton />
      </Box>
    </Box>
  );
};

export default Footer;
